export const formatCount = (value) => {
  const numericValue = typeof value === 'number' ? value : Number(value);

  if (!Number.isFinite(numericValue)) {
    return '---';
  }

  if (Math.abs(numericValue) >= 1_000_000_000) {
    return `${(numericValue / 1_000_000_000).toFixed(1)}B`;
  }

  if (Math.abs(numericValue) >= 1_000_000) {
    return `${(numericValue / 1_000_000).toFixed(1)}M`;
  }

  if (Math.abs(numericValue) >= 1_000) {
    return `${(numericValue / 1_000).toFixed(1)}K`;
  }

  return numericValue.toLocaleString();
};

export default formatCount;
